import React, { useEffect, useState } from "react";
import { Alert, Box, Button, Checkbox, FormField, Modal, SpaceBetween, Textarea } from "@cloudscape-design/components";

const CancelInterventionModal = ({ intervention, onDismiss, onConfirm }) => {
  const [reason, setReason] = useState("");
  const [confirmed, setConfirmed] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    setReason(""); setConfirmed(false); setError(null);
  }, [intervention]);
  const submit = async () => {
    if (saving || !confirmed || !reason.trim() || reason.trim().length > 2000) return;
    setSaving(true); setError(null);
    try {
      await onConfirm({ reason: reason.trim(), confirmedNotStarted: true, approvalVersion: intervention.approvalVersion });
    } catch (err) {
      setError(err?.message || "Cancellation could not be saved. Reload the intervention before trying again.");
    } finally { setSaving(false); }
  };
  if (!intervention) return null;
  return (
    <Modal visible={Boolean(intervention)} header="Cancel intervention" closeAriaLabel="Keep intervention"
      onDismiss={() => { if (!saving) onDismiss(); }}
      footer={<Box float="right"><SpaceBetween direction="horizontal" size="xs">
        <Button disabled={saving} onClick={onDismiss}>Keep intervention</Button>
        <Button variant="primary" loading={saving} disabled={!confirmed || !reason.trim() || reason.trim().length > 2000} onClick={submit}>Confirm cancellation</Button>
      </SpaceBetween></Box>}
    >
      <SpaceBetween size="m">
        <Box variant="strong">{intervention?.title || "Selected intervention"}</Box>
        <Box>This will cancel the intervention and remove its funding from current funding totals. The original approval and planned dates will remain in the file. It will not be recorded as a service delivered.</Box>
        <Box>You cannot activate this intervention after cancellation. This does not withdraw the application, close the action plan, or cancel other interventions.</Box>
        <Box>If there are payment requests or recorded spending, PATH will stop the cancellation so these can be resolved with Finance first.</Box>
        {error && <Alert type="error">{error}</Alert>}
        <FormField label="Reason for cancellation" description="Required. Up to 2,000 characters.">
          <Textarea value={reason} disabled={saving} onChange={({ detail }) => setReason(detail.value)} />
        </FormField>
        <Checkbox checked={confirmed} disabled={saving} onChange={({ detail }) => setConfirmed(detail.checked)}>I confirm that this intervention has not started and should be cancelled.</Checkbox>
      </SpaceBetween>
    </Modal>
  );
};
export default CancelInterventionModal;
